import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, NgModule, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, takeUntil } from 'rxjs';

@Component({
  selector: 'add-button',
  templateUrl: './add-button.component.html',
  standalone: true,
  imports: [CommonModule, ButtonModule, PopoverModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddButtonComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null) // expected data ["edit","active","inactive"] etc

  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }

  showButton = true;
  ngOnInit(): void {
    this.columnData.subscribe({next:(cData:any)=>{
      this.showButton = cData?.trial_type == 'ClassBased' && cData?.status.toLowerCase() == 'active' && this.isAllClassBased(cData);
    }})
  }

  isAllClassBased(data:any){
    if(data.trial_booking)
    {
      return data.trial_booking.filter((o:any)=>o.BookingStatus.toLowerCase() !== 'cancelled' && o.BookingStatus.toLowerCase() !== 'noshow' && o.BookingStatus.toLowerCase() !== 'completed').length <= data.available_trials;
    }
    else{
      return true;
    }
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData: columnData });
  }
}

